export default __webpack_public_path__ + "static/media/c-programming-569564.711c2a38.webp";